import { Component, ElementRef, ViewChild, OnInit, Input, ChangeDetectorRef, HostListener } from '@angular/core';
import { MenuItem } from 'primeng/api';
import { LayoutService } from "../../service/app.layout.service";
import { AuthService } from 'src/app/pages/auth/services/auth.service';
import { NavigationExtras, Router } from '@angular/router';
import { LocalStorageService } from '../../service/local-storage.service';
import { RolesService } from 'src/app/pages/roles/services/roles.service';

@Component({
    selector: 'app-topbar',
    templateUrl: './app.topbar.component.html',
    styleUrls: ['./topbar.component.scss']
})
export class AppTopBarComponent implements OnInit {

    items: MenuItem[] = [];
    @Input() userImage!: any; 
    userName:any;
    roleId:any;
    isFrozenColumn:boolean = false;

    @ViewChild('menubutton') menuButton!: ElementRef;

    @ViewChild('topbarmenubutton') topbarMenuButton!: ElementRef;

    @ViewChild('topbarmenu') menu!: ElementRef;

    constructor(
        public layoutService: LayoutService,
        private _authService: AuthService,
        public _router: Router,
        private _localStorage:LocalStorageService,
        private cdr: ChangeDetectorRef ,
        private _roleService:RolesService
    ) { }

    ngOnInit(): void {
     const topbar = document.querySelector('.layout-topbar')
     console.log(topbar)
      this.checkViewportWidth(); 
        this.getDataFromLocalStorage();
        this.initializeItemsList();
        this._roleService.userImage$.subscribe((image) => {
          this.setDataAndDetectChanges(image);
        });
    }

    getDataFromLocalStorage(){
      this.userImage = this._localStorage.getValue("photo");
      this.userName = this._localStorage.getValue("username");
      this.roleId = parseInt(this._localStorage.getValue("role_id") || '0'); // Default to 0 if roleId is not available
    }

    setDataAndDetectChanges(image: any) {
      this.userImage = image;
      console.log("passed user image", this.userImage)
      this.cdr.detectChanges();
    }

    initializeItemsList() {
        this.items = [
          {
            label: 'Profile Settings', icon: 'pi pi-cog', command: (event)=> {          
              let navigationExtras: NavigationExtras = {
                state: {
                    selfUser: true
                }
            };
            this._router.navigate(['/profile-detail'], navigationExtras);
            }
          },
          {
            label: 'Company Profile',
            icon: 'pi pi-building',
            command: () => {
                if (this.roleId === 1 || this.roleId === 2) {
                    this._router.navigate(['/company-detail']);
                } else {
                    console.log('Hiding Change Company option');
                }
            },
            visible: this.isChangeCompanyVisible()
        },
          {
            label: 'Logout', icon: 'pi pi-fw pi-power-off', command: (event)=> {          
              this.logout()
            }
          },
        ];
    }

    logout() {
        const refreshTokenStr = localStorage?.getItem('r_ad_token');
        const refreshToken = refreshTokenStr ? JSON.parse(refreshTokenStr) : null;
        // this._authService.logout(refreshToken).subscribe(res => {
            // if (res?.error) {
            // }
            //  else {
               this._localStorage.deleteAll();
                this._router?.navigate(['/login']);
            // }
        // })
    }


    isChangeCompanyVisible(): boolean {
      const roleId = parseInt(this.roleId); // Ensure roleId is of type number
      return roleId === 1 || roleId === 2;
  }
  checkViewportWidth() {
    this.isFrozenColumn = window.innerWidth < 500;
  }
  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.checkViewportWidth();
  }
}
